import { PermissionsContextEnum } from 'generated/resources/graphql'

import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'
import PermissionPolicy from 'modules/core/store/models/policies/PermissionPolicy'

interface IPermission {
  authorized: boolean
  category: string | null // FIXME: Make non nullable
  category_label: string | null // FIXME: Make non nullable
  context: PermissionsContextEnum
  context_less: boolean
  id: string
  permissions_group_id: number
  resource: string | null
  verb: string
  verb_label: string
  verb_description: string
}

class Permission extends ModelWithPolicy<IPermission> {
  static urlRoot() {
    return '/permissions/permissions'
  }

  get policy() {
    return new PermissionPolicy(this)
  }

  get verbLabel() {
    return this.attributes.verb_label
  }

  get category() {
    return this.attributes.category
  }

  get categoryLabel() {
    return this.attributes.category_label
  }
}

export default Permission
